import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import { Overlay } from './Overlay';

interface AppUpdateNotificationProps {
  show: boolean;
  onUpdate: () => void;
}

const AppUpdateNotification: React.FC<AppUpdateNotificationProps> = ({ show, onUpdate }) => {
  const { t } = useI18n();

  if (!show) {
    return null;
  }

  return (
    <Overlay title={t('update.title')}>
      <div className="update-notification-content">
        <p>{t('update.message')}</p>
        <button onClick={onUpdate}>{t('update.reload')}</button>
      </div>
    </Overlay>
  );
};

export default AppUpdateNotification;